import { useQuery } from '@tanstack/react-query';

import { useServicesContext } from '../../../contexts/ServicesContext';
import { GetArticlesRequestTypes } from '../../../api/queries';

export enum GetArticlesCacheKey {
  GetArticles = 'GET_ARTICLES',
}

type useGetArticlesQueryProps = GetArticlesRequestTypes & {
  disabled?: boolean;
};

export const useGetArticlesQuery = ({
  pageNumber = 1,
  pageSize = 5,
  sortBy = 'asc',
  labelIds = '',
  isGlobalGuide = false,
  disabled = false,
}: useGetArticlesQueryProps) => {
  const { getArticles } = useServicesContext();
  return useQuery({
    queryKey: [
      GetArticlesCacheKey.GetArticles,
      pageNumber,
      pageSize,
      sortBy,
      labelIds,
      isGlobalGuide,
    ],
    queryFn: () =>
      getArticles({ pageNumber, pageSize, sortBy, labelIds, isGlobalGuide }),
    enabled: !disabled,
    placeholderData: (prev) => prev,
  });
};
